import { render, staticRenderFns } from "./Visit.view.vue?vue&type=template&id=22b4803d&"
import script from "./Visit.view.vue?vue&type=script&lang=js&"
export * from "./Visit.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports